import {type} from "../../common/utils";
import {ActionLocal} from "./actions.service";
import {APP_CONFIG_STATE_INIT, IAppConfig} from "../selector.state";

export class ApplicationConfigActions {

  static ActionType = {
    SET_CONFIG: type('[ApplicationConfigActions] SET_CONFIG'),
  };

  public static setConfiguration(config: IAppConfig): ActionLocal {
    return {
      type: ApplicationConfigActions.ActionType.SET_CONFIG,
      payload: {...APP_CONFIG_STATE_INIT, ...config}
    };
  }
}
